import React from "react";
import "./LoadingSpinner.css";

const LoadingSpinner = () => {
  return <span className="loader"></span>;
};

export default LoadingSpinner;
